import cc from 'classcat';

import { fromCents } from '#src/lib/formatters/numbers';
import { CloudinaryImage } from '#src/components/CloudinaryImage';
import BorderedRow from '#src/components/BorderedRow';
import Link from '#src/components/Link';

import styles from './styles.module.scss';

export const MembershipItem = ({
  amount,
  className,
  content: { removeItemLabel },
  isRemovable,
  itemContent,
  itemId,
  onRemove,
  theme,
}) => {
  const handleRemove = () => onRemove(itemId);
  const { title, description, legacyImageUrl, image } = itemContent || {};
  const removeMe = isRemovable && (
    <Link theme={theme} onClick={handleRemove} className={styles.remove}>
      {removeItemLabel}
    </Link>
  );

  return (
    <BorderedRow className={cc([styles.container, className])}>
      <div className={styles.media}>
        {!!legacyImageUrl && (
          <img src={legacyImageUrl} className={styles.image} />
        )}
        {!!image?.publicId && (
          <CloudinaryImage
            image={image}
            width={213}
            height={213}
            crop="fill"
            className={styles.image}
          />
        )}
        {removeMe}
      </div>
      <div className={styles.content}>
        <h2
          className={styles.heading}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: description?.html }}
        />
        {removeMe}
      </div>
      <div className={styles.amount}>{fromCents(amount)}</div>
    </BorderedRow>
  );
};

MembershipItem.defaultProps = {
  theme: 'waybetter',
};
